module.exports = __webpack_public_path__ + "media/components/src/assets/images/embedded_parts/map-64fccf1546b5d1f4145db679fc945f89.jpg";